export const EXPANDED_SIDEBAR_WIDTH = "280px";
export const COLLAPSED_SIDEBAR_WIDTH = "54px";

export const SIDEBAR_PADDING_X = 2;
